import '@assets/styles/Style.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.css';
import Icon from '@components/Icon';

import React, { useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Session from './SessionPage';

const SessionPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasInjectedHistoryRef = useRef(false);

  const isGeneration = location.pathname.startsWith('/generation/');
  const logoTo = isGeneration ? '/' : '/companions';

  // When on generation make browser back go to home
  useEffect(() => {
    if (!isGeneration) {
      hasInjectedHistoryRef.current = false;
      return;
    }
    if (hasInjectedHistoryRef.current) return;
    hasInjectedHistoryRef.current = true;
    const current = location.pathname + location.search;
    window.history.pushState(null, '', '/');
    window.history.pushState(null, '', current);
  }, [isGeneration, location.pathname, location.search]);

  useEffect(() => {
    if (!isGeneration) return;
    const handlePopState = () => {
      if (window.location.pathname === '/') {
        navigate('/', { replace: true });
      }
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [isGeneration, navigate]);

  return (
    <>
      <Link
        to={logoTo}
        className="fixed top-[17px] md:top-[28px] left-4 md:left-6 h-8 w-auto hidden sm:flex items-center gap-6 opacity-100 z-[99999]">
          
        <div className="w-10 h-10 rounded-full bg-black/20 border border-white/20 backdrop-blur-xl flex items-center justify-center shadow-lg">
          <Icon name={"arrow-left"} size={18} color="#FFFFFF" />
        </div>
        <img
          src="/assets/images/logo_napster_white.svg"
          alt="Napster"
          className="h-8"
        />
      </Link>
      <div className="!fixed !w-screen !h-screen !left-0 bg-black !inset-0 text-left opacity-100  !z-[2000]">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-white/10 to-white/0" />
        <Session />
      </div>
    </>
  );
};

export default SessionPage;
